import React, { useEffect, useId, useState } from 'react';
import styles from './TextArea.module.scss';
import Label from '../label/Label';
import { useBrandingContext } from 'app-context/BrandingsContext';
import Modal from 'component/hoc/modal/Modal';

const TextArea = ({
  label,
  placeholder,
  name,
  value,
  onChange,
  onBlur,
  style,
  type,
  disabled,
  error,
  touched,
  isExpanded,
  minHeight,
  ...props
}) => {
  const { brandingData } = useBrandingContext();
  const { page_TextColor, page_ButtonColor } = brandingData;
  const id = useId();

  const [initialValue, setInitialValue] = useState(value);
  const [expand, setExpand] = useState(false);

  useEffect(() => {
    setInitialValue(value);
  }, [value]);
  const handleChange = (event) => {
    const newValue = event.target.value;
    setInitialValue(newValue);
    if (onChange) {
      onChange(event);
    }
  };
  const renderTextarea = (min) => {
    return (
      <div
        className={`${styles['textarea-wrapper']} ${
          disabled ? styles.disabled : ''
        }`}
      >
        {/* <div className={styles['text-svg']}>
          <img src={getSvgByType(type)} alt={appConstants.TYPE.TEXT_AREA} />
        </div> */}

        <textarea
          id={id}
          name={name}
          className={styles.textarea}
          placeholder={placeholder}
          onChange={handleChange}
          onBlur={onBlur}
          style={{ color: page_TextColor, minHeight: min }}
          value={initialValue}
          disabled={disabled}
          {...props}
        />
      </div>
    );
  };
  return (
    <>
      <div className={`${styles['textarea-container']}`} style={style}>
        <div className={`${styles['label-cont']}`}>
          {label ? (
            <Label
              text={label}
              htmlFor={id}
              classname={disabled ? styles['label-disable'] : ''}
            />
          ) : null}

          {isExpanded && initialValue !== '' ? (
            <p
              style={{ color: page_ButtonColor, cursor: 'pointer' }}
              onClick={() => setExpand(true)}
            >
              Expand
            </p>
          ) : null}
        </div>
        {renderTextarea()}
        {error && touched && <p className="error-message">{error}</p>}
      </div>
      <Modal isOpen={expand} onClose={() => setExpand(false)} title={label}>
        {renderTextarea(minHeight)}
      </Modal>
    </>
  );
};

export default TextArea;
